import { render, staticRenderFns } from "./AddonsDetailSummary.vue?vue&type=template&id=e917bb3c"
import script from "./AddonsDetailSummary.vue?vue&type=script&lang=js"
export * from "./AddonsDetailSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports